/**
 * This is the Registration module configuration.
 * Do NOT configure routes in this file.
 * @memberOf Registration Module
 * @namespace Registration Config
 */

/**
 * @name config
 * @desc Configures the module.
 * @memberOf Registration Module.Registration Config
 * @ngInject
 */
var config = function () {
}

export default config;


// WEBPACK FOOTER //
// ./src/login/registration/registration.config.js